import React from 'react';
import { Table } from 'flowbite-react';
import styled from 'styled-components';

const TableHeadCell = styled(Table.HeadCell)`
    &:first-child {
        border-top-left-radius: 0.5rem !important;
        border-bottom-left-radius: 0.5rem !important;
    }

    &:last-child {
        border-top-right-radius: 0.5rem !important;
        border-bottom-right-radius: 0.5rem !important;
    }
`;

interface TableProps {
    heads: string[];
    children: React.ReactNode;
}

const WTable = ({ children, heads }: TableProps) => {
    return (
        <Table hoverable striped>
            <Table.Head className="rounded-lg">
                {heads.map((item, index) => (
                    <TableHeadCell key={index} className="bg-gray-100">
                        {item}
                    </TableHeadCell>
                ))}
            </Table.Head>
            <Table.Body>{children}</Table.Body>
        </Table>
    );
};

export default WTable;
